var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarSuitcase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 100 125",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.25,28.15509H68V21.86115a9.63782,9.63782,0,0,0-9.627-9.627H41.627A9.63782,9.63782,0,0,0,32,21.86115v6.29394H25.75V87.76581h48.5Zm-12.25,0H38V21.86115a3.631,3.631,0,0,1,3.627-3.627h16.7461A3.631,3.631,0,0,1,62,21.86115Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.12939,28.15509H79.25V87.76581h6.87939A8.87056,8.87056,0,0,0,95,78.8952V37.02557A8.8705,8.8705,0,0,0,86.12939,28.15509Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.87061,87.76581H20.75V28.15509H13.87061A8.8705,8.8705,0,0,0,5,37.02557V78.8952A8.87056,8.87056,0,0,0,13.87061,87.76581Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarSuitcase);
export default __webpack_public_path__ + "static/media/car_suitcase.0a1a7375007058cf841a958ac5d6d871.svg";
export { ForwardRef as ReactComponent };